import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { PhoneIcon, MenuIcon, XIcon } from 'lucide-react';
import { COMPANY, NAV_LINKS } from '../lib/site';
import { MagneticButton } from './fx/MagneticButton';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => setOpen(false), [location.pathname]);
  const primaryLinks = NAV_LINKS.slice(0, 6);
  return <motion.header initial={{
    y: -80,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.8,
    ease: [0.22, 1, 0.36, 1],
    delay: 0.2
  }} className="fixed inset-x-0 top-0 z-[500] flex justify-center px-4 pt-4" data-id="element-109" data-mp="1pxi2oacdivsh">
      <nav className={`glass-strong flex w-full max-w-7xl items-center justify-between rounded-full pl-3 pr-3 shadow-glass transition-all duration-500 ${scrolled ? 'py-1.5' : 'py-2.5'}`} data-id="element-110" data-mp="elpun0b6qji7">
        <Link to="/" className="flex items-center gap-2.5 pl-2" aria-label={COMPANY.fullName} data-id="element-111" data-mp="ojns8eexpsnh">
          <img src={COMPANY.logo} alt="" decoding="async" className={`object-contain transition-all duration-500 ${scrolled ? 'h-9 w-9' : 'h-11 w-11'}`} data-id="element-112" data-mp="3s278sjo93a2g" />
          <span className="font-display text-base font-bold leading-none tracking-tight text-navy" data-id="element-113" data-mp="5n4e1ap9xek2">
            Dream Shield
          </span>
        </Link>

        <div className="hidden items-center gap-1 lg:flex" data-id="element-114" data-mp="34as1echma2kc">
          {primaryLinks.map(link => <NavLink key={link.to} to={link.to} className="group relative rounded-full px-3.5 py-2 text-sm font-medium text-navy/80 transition-colors hover:text-royal" data-id="element-115" data-mp="399mk7efl3r4g">
              {({
            isActive
          }) => <>
                  {link.label}
                  <span className={`absolute inset-x-3.5 -bottom-0.5 h-0.5 origin-left rounded-full bg-royal transition-transform duration-300 ${isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`} data-id="element-116" data-mp="361zwplvcaosz" />
                </>}
            </NavLink>)}
        </div>

        <div className="flex items-center gap-2" data-id="element-117" data-mp="2sav433qe2ws5">
          <div className="hidden md:block" data-id="element-118" data-mp="2s88nyfpfn8yb">
            <MagneticButton variant="emergency" href={COMPANY.phoneHref} className="!py-2.5 !px-5 !text-xs" data-id="element-119" data-mp="2nb8quuak9gjc">
              <PhoneIcon className="h-4 w-4" data-id="element-120" data-mp="2l9pj3o0u5pp" />
              Call Now
            </MagneticButton>
          </div>
          <button type="button" onClick={() => setOpen(o => !o)} aria-label={open ? 'Close menu' : 'Open menu'} className="flex h-11 w-11 items-center justify-center rounded-full text-navy transition-colors hover:bg-sky lg:hidden" data-id="element-121" data-mp="a523lbx62wau">
            {open ? <XIcon className="h-5 w-5" data-id="element-122" data-mp="54xonqbwq9mq" /> : <MenuIcon className="h-5 w-5" data-id="element-123" data-mp="57iok9snafhu" />}
          </button>
        </div>
      </nav>

      <AnimatePresence data-id="element-124" data-mp="xud9f7tdjgvu">
        {open && <motion.div initial={{
        opacity: 0,
        y: -12
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -12
      }} className="glass-strong absolute inset-x-4 top-20 rounded-4xl p-4 shadow-glow lg:hidden" data-id="element-125" data-mp="xtbombmk3g0x">
            <div className="grid grid-cols-2 gap-1" data-id="element-126" data-mp="1gl4i075jf396">
              {NAV_LINKS.map(link => <NavLink key={link.to} to={link.to} className={({
            isActive
          }) => `rounded-2xl px-4 py-3 text-sm font-medium transition-colors ${isActive ? 'bg-royal text-white' : 'text-navy hover:bg-sky'}`} data-id="element-127" data-mp="3p272ss7igxfc">
                  {link.label}
                </NavLink>)}
            </div>
            <a href={COMPANY.phoneHref} className="mt-3 flex items-center justify-center gap-2 rounded-full bg-fire px-5 py-3.5 text-sm font-semibold text-white" data-id="element-128" data-mp="blzfeynbei1u">
              <PhoneIcon className="h-4 w-4" data-id="element-129" data-mp="1vwod3zr7e65" />
              {COMPANY.phoneDisplay}
            </a>
          </motion.div>}
      </AnimatePresence>
    </motion.header>;
}